<template>
  <div class="app-wrapper">
    <div class="sidebar-overlay" @click="toggleSidebar(); showMobileAdminMenu = false;"></div>

    <header class="top-nav indigo darken-3 z-depth-1">

      <div class="valign-wrapper" style="flex: 1;">
        <a href="#!" @click.prevent="toggleSidebar()" class="white-text hover-icon"
          style="margin-right: 20px; display: flex; padding: 5px; border-radius: 50%;">
          <i class="material-icons" style="font-size: 1.8rem;">menu</i>
        </a>

        <div class="logoimg center white circle z-depth-1"
          style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; overflow: hidden; margin-right: 12px;">
          <img src="@/assets/LTOlogo.png" style="width: 80%" />
        </div>
        <h5 class="white-text bold" style="margin: 0; font-size: 1.4rem; letter-spacing: 0.5px;">HR-DOS</h5>
      </div>

      <div class="top-actions valign-wrapper">

        <div style="position: relative; margin-left: 20px; display: flex; align-items: center;">
          <a href="#!" @click.prevent="toggleNotifications" class="white-text hover-icon"
            style="position: relative; padding: 5px; border-radius: 50%; display: flex;">
            <i class="material-icons">notifications</i>
            <span v-if="unreadCount > 0" class="red accent-2 badge circle white-text"
              style="position: absolute; top: -2px; right: -2px; width: 18px; height: 18px; line-height: 18px; padding: 0; min-width: 0; border-radius: 50%; font-size: 0.7rem; text-align: center; font-weight: bold;">
              {{ unreadCount }}
            </span>
          </a>

          <div v-if="showNotifications" class="notification-dropdown z-depth-3">
            <div class="dropdown-header indigo darken-4 white-text">
              <span class="bold">Notifications</span>
              <a href="#!" @click.prevent="markAllAsRead" class="white-text right"
                style="font-size: 0.8rem; text-decoration: underline;">Mark all read</a>
            </div>

            <ul class="dropdown-content-list" style="max-height: 400px; overflow-y: auto; background-color: #f8f9fa;">
              <li v-if="notifications.length === 0" class="center-align grey-text" style="padding: 30px 20px; background-color: #fff;">
                <i class="material-icons" style="font-size: 2.5rem; color: #e0e0e0; margin-bottom: 10px;">notifications_none</i><br>
                No notifications found
              </li>

              <!-- ================= UNREAD SECTION ================= -->
              <template v-if="unreadNotifications.length > 0">
                <div class="notif-section-title">New</div>
                <li v-for="notif in unreadNotifications" :key="'unread-'+notif.id" 
                  class="notification-item unread-notif"
                  @click="handleNotificationClick(notif)">
                  
                  <div class="unread-dot indigo darken-1"></div>

                  <div style="flex: 1;">
                    <div class="notif-title bold indigo-text text-darken-4">
                      {{ notif.data.title || 'System Alert' }}
                    </div>
                    <div class="notif-text grey-text text-darken-3">
                      {{ notif.data.message }}
                    </div>
                    <div class="notif-time indigo-text text-lighten-1" style="font-size: 0.7rem; margin-top: 4px; font-weight: 600;">
                      {{ formatDate(notif.created_at) }}
                    </div>
                  </div>
                </li>
              </template>

              <!-- ================= READ SECTION ================= -->
              <template v-if="readNotifications.length > 0">
                <div class="notif-section-title" v-if="unreadNotifications.length > 0">Earlier</div>
                <li v-for="notif in readNotifications" :key="'read-'+notif.id" 
                  class="notification-item read-notif"
                  @click="handleNotificationClick(notif)">
                  
                  <div style="width: 8px; margin-right: 12px; flex-shrink: 0;"></div> <!-- Spacer -->

                  <div style="flex: 1;">
                    <div class="notif-title grey-text text-darken-1">
                      {{ notif.data.title || 'System Alert' }}
                    </div>
                    <div class="notif-text grey-text text-darken-1">
                      {{ notif.data.message }}
                    </div>
                    <div class="notif-time grey-text text-lighten-2" style="font-size: 0.7rem; margin-top: 4px;">
                      {{ formatDate(notif.created_at) }}
                    </div>
                  </div>
                </li>
              </template>

            </ul>
          </div>
        </div>

        <div style="position: relative; display: flex; align-items: center;">
          <div @click="toggleProfileMenu" class="hide-on-small-only valign-wrapper hover-icon"
            style="margin-left: 15px; padding: 4px 10px; border-radius: 20px; cursor: pointer;">
            <img :src="getProfilePhoto()" alt="Avatar" class="circle"
              style="width: 32px; height: 32px; margin-right: 10px; object-fit: cover;" />
            <div class="white-text" style="display: flex; flex-direction: column; line-height: 1.1;">
              <span class="bold" style="font-size: 0.85rem; text-transform: uppercase;">{{ getDisplayName() }}</span>
            </div>
            <i class="material-icons white-text" style="margin-left: 5px; font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div v-if="showProfileMenu" class="profile-dropdown z-depth-3">
            <ul class="dropdown-content-list" style="max-height: none;">
              <!-- New Change Password Button (Superadmin Only) -->
              <li v-if="currentUser?.role === 'superadmin'" class="profile-dropdown-item-1" @click="openChangePasswordModal">
                <i class="material-icons" style="color: #1976d2; margin-right: 10px; vertical-align: middle;">vpn_key</i>
                <span class="bold" style="color: #1976d2; font-size: 0.95rem;">Change Password</span>
              </li>
              
              <!-- Existing Logout Button -->
              <li class="profile-dropdown-item" @click="logout">
                <i class="material-icons" style="color: #ff5252; margin-right: 10px; vertical-align: middle;">power_settings_new</i>
                <span class="bold" style="color: #ff5252; font-size: 0.95rem;">Logout</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <aside class="custom-sidebar white z-depth-1">
      <div class="profile-card-wrapper" style="padding: 20px 15px 10px 15px;">
        <div class="profile-card z-depth-1" style="background-color: #283593; border-radius: 8px; overflow: hidden;">
          <div style="background-color: #e0e0e0; height: 45px;"></div>
          <div class="center-align" style="margin-top: -25px; padding-bottom: 15px;">
            <img :src="getProfilePhoto()" alt="Avatar" class="circle z-depth-2 white"
              style="width: 60px; height: 60px; object-fit: cover; border: 3px solid white;" />
            <div class="white-text bold truncate"
              style="margin-top: 5px; font-size: 1rem; padding: 0 10px; text-transform: uppercase;">
              {{ getDisplayName() }}
            </div>
            <div class="indigo-text text-lighten-4 truncate"
              style="font-size: 0.8rem; text-transform: capitalize; padding: 0 10px;">
              {{ extractPositionTitleInParentheses(currentUser?.employee?.position_title) || currentUser?.role || 'HR-DOS User' }}
            </div>
          </div>
        </div>
      </div>
      
      <ul class="sidebar-nav" style="margin-top: 10px; padding-bottom: 20px;">
        <!-- My Profile Nav -->
        <li :class="['nav-item', { 'active-nav indigo lighten-5': $route.path === '/my-profile' }]" v-if="hasNoAccess([0])">
          <router-link to="/my-profile" @click="closeSidebarOnMobile" class="valign-wrapper nav-link" style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper" :class="$route.path === '/my-profile' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons" :class="$route.path === '/my-profile' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'" style="margin-right: 15px;">person</i>
              <span class="bold">My Profile</span>
            </div>
          </router-link>
        </li>
        <!-- Dashboard Nav -->
        <li
          :class="['nav-item', { 'active-nav indigo lighten-5': $route.path === '/dashboard' || $route.path === '/' }]" v-if="hasAccess([0, 8])">
          <router-link to="/dashboard" @click="closeSidebarOnMobile" class="valign-wrapper nav-link"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="$route.path === '/dashboard' || $route.path === '/' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="$route.path === '/dashboard' || $route.path === '/' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">dashboard</i>
              <span class="bold">Dashboard</span>
            </div>
            <i v-if="$route.path === '/dashboard' || $route.path === '/'"
              class="material-icons indigo-text text-darken-3" style="font-size: 1.2rem;">keyboard_arrow_right</i>
          </router-link>
        </li>

        <!-- Employees Nav List -->
        <li :class="['nav-item custom-collapse-wrapper', { 'active-nav indigo lighten-5': openMenu === 'employees' }]" v-if="hasAccess([0, 1, 2, 3, 8])">
          <div class="custom-collapse-header valign-wrapper" @click="toggleAccordion('employees')"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="openMenu === 'employees' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="openMenu === 'employees' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">people</i>
              <span class="bold">Employees</span>
            </div>
            <i class="material-icons arrow-icon"
              :class="openMenu === 'employees' ? 'indigo-text text-darken-3 rotate-arrow' : 'grey-text text-darken-1'"
              style="font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div class="custom-collapse-body" :style="{ maxHeight: openMenu === 'employees' ? '300px' : '0px' }">
            <ul class="sub-nav-list">
              <li v-if="hasAccess([0, 1, 2, 3, 8])">
                <router-link to="/employees" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/employees' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/employees' ? 'indigo-text text-darken-2' : ''">•</span> Employee List
                </router-link>
              </li>
              <li>
                <router-link to="/my-registrations" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/my-registrations' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/my-registrations' ? 'indigo-text text-darken-2' : ''">•</span> My
                  Registrations
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/unlock-requests" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/unlock-requests' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/unlock-requests' ? 'indigo-text text-darken-2' : ''">•</span> Reopen
                  Requests
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/edit-requests" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper" 
                  :class="$route.path === '/edit-requests' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/edit-requests' ? 'indigo-text text-darken-2' : ''">•</span> Edit Requests
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/employees-signup-requests" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/employees-signup-requests' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/employees-signup-requests' ? 'indigo-text text-darken-2' : ''">•</span>
                  Signup Requests
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/add-salary-grade" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/add-salary-grade' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/add-salary-grade' ? 'indigo-text text-darken-2' : ''">•</span> Manage
                  Salary
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- DTR Management Nav List -->
        <li :class="['nav-item custom-collapse-wrapper', { 'active-nav indigo lighten-5': openMenu === 'dtr' }]">
          <div class="custom-collapse-header valign-wrapper" @click="toggleAccordion('dtr')"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="openMenu === 'dtr' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="openMenu === 'dtr' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">access_time</i>
              <span class="bold">DTR Management</span>
            </div>
            <i class="material-icons arrow-icon"
              :class="openMenu === 'dtr' ? 'indigo-text text-darken-3 rotate-arrow' : 'grey-text text-darken-1'"
              style="font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div class="custom-collapse-body" :style="{ maxHeight: openMenu === 'dtr' ? '300px' : '0px' }">
            <ul class="sub-nav-list">
              <li>
                <router-link to="/employee/dtr" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/employee/dtr' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/employee/dtr' ? 'indigo-text text-darken-2' : ''">•</span> My DTR
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/admin/dtr-upload" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/admin/dtr-upload' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/admin/dtr-upload' ? 'indigo-text text-darken-2' : ''">•</span> DTR Upload
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/hr/dtr/review" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/hr/dtr/review' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/hr/dtr/review' ? 'indigo-text text-darken-2' : ''">•</span> DTR Review
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/hr/dtr/validation" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/hr/dtr/validation' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/hr/dtr/validation' ? 'indigo-text text-darken-2' : ''">•</span> Dispute Validation
                </router-link>
              </li>
              <li v-if="hasAccess([0, 1, 2, 3])">
                <router-link to="/chief/dtr/employees" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/chief/dtr/employees' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/chief/dtr/employees' ? 'indigo-text text-darken-2' : ''">•</span> DTR Disputes
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Leave Application Nav List -->
        <li :class="['nav-item custom-collapse-wrapper', { 'active-nav indigo lighten-5': openMenu === 'leave' }]">
          <div class="custom-collapse-header valign-wrapper" @click="toggleAccordion('leave')"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="openMenu === 'leave' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="openMenu === 'leave' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">date_range</i>
              <span class="bold">Leave Management</span>
            </div>
            <i class="material-icons arrow-icon"
              :class="openMenu === 'leave' ? 'indigo-text text-darken-3 rotate-arrow' : 'grey-text text-darken-1'"
              style="font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div class="custom-collapse-body" :style="{ maxHeight: openMenu === 'leave' ? '300px' : '0px' }">
            <ul class="sub-nav-list">
              <li>
                <router-link to="/apply-leave" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/apply-leave' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/apply-leave' ? 'indigo-text text-darken-2' : ''">•</span> Apply Leave
                </router-link>
              </li>
              <li v-if="hasNoAccess([0])">
                <router-link to="/my-leave-requests" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/my-leave-requests' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/my-leave-requests' ? 'indigo-text text-darken-2' : ''">•</span> My Requests
                </router-link>
              </li>
              <li v-if="hasAccess([8, 1, 2, 3])">
                <router-link to="/leave-management" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="['/leave-management', '/leave-action'].some(path => $route.path.startsWith(path)) ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="['/leave-management', '/leave-action'].some(path => $route.path.startsWith(path)) ? 'indigo-text text-darken-2' : ''">•</span>
                  Leave Applications
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/leave-balances" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/leave-balances' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot"
                    :class="$route.path === '/leave-balances' ? 'indigo-text text-darken-2' : ''">•</span> Leave Balances
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Trainings Nav List -->
        <li :class="['nav-item custom-collapse-wrapper', { 'active-nav indigo lighten-5': openMenu === 'trainings' }]">
          <div class="custom-collapse-header valign-wrapper" @click="toggleAccordion('trainings')"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="openMenu === 'trainings' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="openMenu === 'trainings' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">school</i>
              <span class="bold">Trainings</span>
            </div>
            <i class="material-icons arrow-icon"
              :class="openMenu === 'trainings' ? 'indigo-text text-darken-3 rotate-arrow' : 'grey-text text-darken-1'"
              style="font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div class="custom-collapse-body" :style="{ maxHeight: openMenu === 'trainings' ? '300px' : '0px' }">
            <ul class="sub-nav-list">
              <li>
                <router-link to="/employee/my-trainings" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/employee/my-trainings' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/employee/my-trainings' ? 'indigo-text text-darken-2' : ''">•</span> My Trainings
                </router-link>
              </li>
              <!-- HR (incl. Assistant): this page is where attendance is
                   marked AND uploaded certificates are reviewed. Attendance is
                   an assistant task, so the item stays visible; the approval
                   section inside the page is gated separately for HR Admin. -->
              <li v-if="hasAccess([0, 8])">
                <router-link to="/hr/training-approvals" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/hr/training-approvals' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/hr/training-approvals' ? 'indigo-text text-darken-2' : ''">•</span> Training Approvals
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/admin/training-masterlist" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/admin/training-masterlist' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/admin/training-masterlist' ? 'indigo-text text-darken-2' : ''">•</span> Training Masterlist
                </router-link>
              </li>
              <!-- Director only: in-house certificates are issued in their
                   name, so signing them is not an HR task. -->
              <li v-if="hasAccess([0, 1])">
                <router-link to="/training-certificates/sign" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/training-certificates/sign' ? 'indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/training-certificates/sign' ? 'indigo-text text-darken-2' : ''">•</span> Sign Certificates
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!------------------------------EMPLOYEE FORMS------------------------------------->
        <li :class="['nav-item custom-collapse-wrapper', { 'active-nav indigo lighten-5': openMenu === 'd201' }]">
          <div class="custom-collapse-header valign-wrapper" @click="toggleAccordion('d201')"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="openMenu === 'd201' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="openMenu === 'd201' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">description</i>
              <span class="bold">Employee Forms</span>
            </div>
            <i class="material-icons arrow-icon"
              :class="openMenu === 'd201' ? 'indigo-text text-darken-3 rotate-arrow' : 'grey-text text-darken-1'"
              style="font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div class="custom-collapse-body" :style="{ maxHeight: openMenu === 'd201' ? '300px' : '0px' }">
            <ul class="sub-nav-list">
              <li v-if="hasAccess([0, 8])">
                <router-link to="/201management" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/201management' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/201management' ? 'indigo-text text-darken-2' : ''">•</span>
                  Employee files
                </router-link>
              </li>
              <li v-if="hasAccess([0, 8])">
                <router-link to="/201queue" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/201queue' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/201queue' ? 'indigo-text text-darken-2' : ''">•</span>
                  Review queue
                </router-link>
              </li>
              <li v-if="hasPosition([0, 8])">
                <router-link to="/service-record-queue" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/service-record-queue' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/service-record-queue' ? 'indigo-text text-darken-2' : ''">•</span>
                  Service record approvals
                </router-link>
              </li>
              <li>
                <router-link to="/my-201-file" @click="closeSidebarOnMobile" class="sub-nav-link valign-wrapper"
                  :class="$route.path === '/my-201-file' ? 'active-sub-nav indigo-text text-darken-4 bold' : 'grey-text text-darken-2'">
                  <span class="sub-dot" :class="$route.path === '/my-201-file' ? 'indigo-text text-darken-2' : ''">•</span>
                  My Forms
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!------------------------------AUDIT LOGS---------------------------------------->
        <!-- Flat item rather than a collapsible: it is a single read-only
             page. HR Admin position only — the log oversees what the HR
             Assistant does, so hasPosition() (no role=admin bypass) is used
             to match the backend position_id:0,8 guard. -->
        <li
          :class="['nav-item', { 'active-nav indigo lighten-5': $route.path === '/admin/audit-logs' }]"
          v-if="hasPosition([0, 8])"
        >
          <router-link to="/admin/audit-logs" @click="closeSidebarOnMobile" class="valign-wrapper nav-link"
            style="width: 100%; justify-content: space-between;">
            <div class="valign-wrapper"
              :class="$route.path === '/admin/audit-logs' ? 'indigo-text text-darken-4' : 'grey-text text-darken-3'">
              <i class="material-icons"
                :class="$route.path === '/admin/audit-logs' ? 'indigo-text text-darken-3' : 'grey-text text-darken-1'"
                style="margin-right: 15px;">history</i>
              <span class="bold">Audit Logs</span>
            </div>
            <i v-if="$route.path === '/admin/audit-logs'"
              class="material-icons indigo-text text-darken-3" style="font-size: 1.2rem;">keyboard_arrow_right</i>
          </router-link>
        </li>

      </ul>

      <ul :class="currentUser?.role === 'superadmin' ? 'sidebar-option-btn hide-on-med-and-up' : 'sidebar-logout-btn hide-on-med-and-up'" style="max-height: none; position: relative;">
        
        <!-- SUPERADMIN VIEW: Clickable Toggle & Dropdown -->
        <template v-if="currentUser?.role === 'superadmin'">
          
          <!-- Invisible overlay to close menu when clicking outside -->
          <div v-if="showMobileAdminMenu" class="mobile-options-overlay" @click="showMobileAdminMenu = false"></div>

          <!-- The Dropdown (Pops upwards) -->
          <div v-if="showMobileAdminMenu" class="z-depth-2 admin-mobile-dropdown" style="position: absolute; bottom: 100%; right: 0; width: 65%; background: #212121; border-top: 1px solid #424242; z-index: 11;">
            <li class="profile-dropdown-item-1 dark-hover" @click="openChangePasswordModal" style="border-bottom: 1px solid #424242;">
              <i class="material-icons" style="color: #90caf9; margin-right: 10px; vertical-align: middle;">vpn_key</i>
              <span class="bold" style="color: #ffffff; font-size: 0.95rem;">Change Password</span>
            </li>
            <li class="profile-dropdown-item dark-hover" @click="logout">
              <i class="material-icons" style="color: #ef5350; margin-right: 10px; vertical-align: middle;">power_settings_new</i>
              <span class="bold" style="color: #ffffff; font-size: 0.95rem;">Logout</span>
            </li>
          </div>
          
          <!-- The Toggle Button (Completely removed .profile-dropdown-item to fix the red hover bug) -->
          <li class="mobile-admin-options-btn" :class="{ 'active-options': showMobileAdminMenu }" @click="showMobileAdminMenu = !showMobileAdminMenu" style="justify-content: space-between; z-index: 11; position: relative; transition: background-color 0.2s;">
            <div style="display: flex; align-items: center;">
              <i class="material-icons" :class="showMobileAdminMenu ? 'black-text' : 'blue-grey-text text-darken-3'" style="margin-right: 10px; vertical-align: middle;">settings</i>
              <span class="bold" :class="showMobileAdminMenu ? 'black-text' : 'blue-grey-text text-darken-3'" style="font-size: 0.95rem;">Options</span>
            </div>
            <i class="material-icons" :class="showMobileAdminMenu ? 'black-text' : 'blue-grey-text text-darken-3'">{{ showMobileAdminMenu ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</i>
          </li>
        </template>

        <!-- REGULAR USER VIEW: Direct Logout -->
        <template v-else>
          <li class="profile-dropdown-item" @click="logout">
            <i class="material-icons" style="color: #ff5252; margin-right: 10px; vertical-align: middle;">power_settings_new</i>
            <span class="bold" style="color: #ff5252; font-size: 0.95rem;">Logout</span>
          </li>
        </template>

      </ul>
    </aside>

    <main class="main-content grey lighten-5">
      <div class="page-content">
        <slot />
      </div>
    </main>

    <!-- Forced Password Change Modal Component with View/Hide Toggles and Validations -->
    <div id="forcePasswordModal" class="modal centered-modal" style="width: 90%; max-width: 450px; border-radius: 12px;">
      <div class="modal-content center-align" style="padding: 40px 24px 20px;">
        <i class="material-icons amber-text" style="font-size: 4rem; margin-bottom: 10px;">vpn_key</i>
        <h5 style="font-weight: 600;">Temporary Password Detected</h5>
        <p class="grey-text text-darken-2">For your security, you must change your temporary password before you can continue using HR-DOS.</p>
        
        <form @submit.prevent="submitNewPassword" style="margin-top: 20px;" class="left-align">
          
          <div class="input-field" style="position: relative;">
            <input 
              id="force_new_pass" 
              class="validate"
              :class="{ 'invalid': forcePasswordError }"
              :type="isForceNewPasswordVisible ? 'text' : 'password'" 
              v-model="forcePasswordForm.password" 
              required 
              minlength="8"
            >
            <label for="force_new_pass">New Password (Min 8 chars)</label>
            <i 
              class="material-icons password-toggle" 
              @click="isForceNewPasswordVisible = !isForceNewPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;"
            >
              {{ isForceNewPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div class="input-field" style="position: relative;">
            <input 
              id="force_new_pass_confirmation" 
              class="validate"
              :class="{ 'invalid': forcePasswordError }"
              :type="isForceConfirmPasswordVisible ? 'text' : 'password'" 
              v-model="forcePasswordForm.password_confirmation" 
              required 
              minlength="8"
            >
            <label for="force_new_pass_confirmation">Confirm New Password</label>
            <i 
              class="material-icons password-toggle" 
              @click="isForceConfirmPasswordVisible = !isForceConfirmPasswordVisible" 
              style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;"
            >
              {{ isForceConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <p class="red-text center-align" v-if="forcePasswordError" style="margin-top: 5px; font-size: 0.9rem;">
            {{ forcePasswordError }}
          </p>

          <div class="center-align" style="margin-top: 30px;">
            <button type="submit" class="btn blue darken-1" :disabled="forcePasswordLoading" style="width: 100%; border-radius: 6px; height: 45px;">
              <span v-if="forcePasswordLoading">Updating Password...</span>
              <span v-else>Save New Password</span>
            </button>
          </div>
        </form>

      </div>
    </div>

    <!-- Manual Change Password Modal (Superadmin Only) -->
    <div id="changePasswordModal" class="modal centered-modal" style="width: 90%; max-width: 450px; border-radius: 12px;">
      <div class="modal-content left-align" style="padding: 30px 24px 20px;">
        <h5 style="font-weight: 600; margin-bottom: 20px; text-align: center;">Change Password</h5>

        <form @submit.prevent="submitChangePassword">
          <div class="input-field" style="position: relative;">
            <input 
              id="change_current_pass" 
              class="validate"
              :class="{ 'invalid': changePasswordError }"
              :type="isChangeOldVisible ? 'text' : 'password'" 
              v-model="changePasswordForm.old" 
              required
            >
            <label for="change_current_pass">Current Password</label>
            <i class="material-icons password-toggle" @click="isChangeOldVisible = !isChangeOldVisible" style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;">
              {{ isChangeOldVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div class="input-field" style="position: relative;">
            <input 
              id="change_new_pass" 
              class="validate"
              :class="{ 'invalid': changePasswordError }"
              :type="isChangeNewVisible ? 'text' : 'password'" 
              v-model="changePasswordForm.new" 
              required 
              minlength="8"
            >
            <label for="change_new_pass">New Password (Min 8 chars)</label>
            <i class="material-icons password-toggle" @click="isChangeNewVisible = !isChangeNewVisible" style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;">
              {{ isChangeNewVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <div class="input-field" style="position: relative;">
            <input 
              id="change_new_pass_confirmation" 
              class="validate"
              :class="{ 'invalid': changePasswordError }"
              :type="isChangeConfirmVisible ? 'text' : 'password'" 
              v-model="changePasswordForm.confirm" 
              required 
              minlength="8"
            >
            <label for="change_new_pass_confirmation">Confirm New Password</label>
            <i class="material-icons password-toggle" @click="isChangeConfirmVisible = !isChangeConfirmVisible" style="position: absolute; right: 3px; bottom: 15px; cursor: pointer; z-index: 2;">
              {{ isChangeConfirmVisible ? 'visibility_off' : 'visibility' }}
            </i>
          </div>

          <p class="red-text center-align" v-if="changePasswordError" style="margin-top: 5px; font-size: 0.9rem;">
            {{ changePasswordError }}
          </p>

          <div class="right-align" style="margin-top: 30px;">
            <button type="button" class="btn-flat modal-close waves-effect" @click="closeChangePasswordModal" :disabled="changePasswordLoading" style="margin-right: 10px;">Cancel</button>
            <button type="submit" class="btn blue darken-1" :disabled="changePasswordLoading" style="border-radius: 6px;">
              <span v-if="changePasswordLoading">Saving...</span>
              <span v-else>Update Password</span>
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { api, apiURL } from "@/axios";
import defaultPic from '@/assets/picDefault.png';

export default {
  name: "AdminAppLayout",
  props: {
    title: String,
  },
  data() {
    let cachedUser = null;
    try {
      cachedUser = JSON.parse(localStorage.getItem('hrdos_user'));
    } catch (e) {
      cachedUser = null;
    }

    return {
      collapsed: false,
      openMenu: null,

      notifications: [],
      showNotifications: false,
      showProfileMenu: false,
      currentUser: cachedUser,

      // Store the polling interval ID so we can clear it on dismount
      notificationPollingInterval: null,

      // Forced Password Change data
      forcePasswordModalInstance: null,
      forcePasswordLoading: false,
      forcePasswordForm: {
        password: "",
        password_confirmation: ""
      },
      forcePasswordError: "",
      isForceNewPasswordVisible: false,
      isForceConfirmPasswordVisible: false,

      // Manual Change Password data (Superadmin)
      changePasswordModalInstance: null,
      changePasswordLoading: false,
      changePasswordForm: {
        old: "",
        new: "",
        confirm: ""
      },
      changePasswordError: "",
      isChangeOldVisible: false,
      isChangeNewVisible: false,
      isChangeConfirmVisible: false,
      showMobileAdminMenu: false,
    };
  },
  computed: {
    unreadNotifications() {
      return this.notifications.filter(n => n.read_at === null);
    },
    readNotifications() {
      return this.notifications.filter(n => n.read_at !== null);
    },
    unreadCount() {
      return this.unreadNotifications.length;
    }
  },
  watch: {
    $route() {
      this.checkActiveRoute();
      this.showProfileMenu = false;
      this.showNotifications = false;
      // Explicitly handle mobile sidebar hide on route change
      if (window.innerWidth <= 992) {
        document.body.classList.remove("mobile-active");
      }
    }
  },
  mounted() {
    if (this.title) {
      document.title = this.title;
    }
    
    this.checkActiveRoute();
    this.fetchNotifications();
    this.fetchCurrentUser();

    // Start background polling for notifications every 30 seconds
    this.startNotificationPolling();

    // Initialize Materialize Modal for Forced Password Change
    const elem = document.getElementById('forcePasswordModal');
    if (elem) {
      this.forcePasswordModalInstance = window.M.Modal.init(elem, {
        dismissible: false, 
        endingTop: '10%'
      });
    }

    // Initialize Materialize Modal for Manual Change Password
    const changePassElem = document.getElementById('changePasswordModal');
    if (changePassElem) {
      this.changePasswordModalInstance = window.M.Modal.init(changePassElem, {
        dismissible: false,
        endingTop: '10%'
      });
    }

    // Listen for global event dispatched from axios.js interceptor
    window.addEventListener('open-force-password-modal', this.openForcePasswordModal);
  },
  beforeUnmount() {
    window.removeEventListener('open-force-password-modal', this.openForcePasswordModal);

    // Clear the polling interval to prevent memory leaks
    if (this.notificationPollingInterval) {
      clearInterval(this.notificationPollingInterval);
    }

    if (window.Echo && this.currentUser) {
      window.Echo.leave(`App.Models.User.${this.currentUser.id}`);
    }
  },
  methods: {
    startNotificationPolling() {
      // Poll every 1 seconds (1000 ms). Adjust as needed.
      this.notificationPollingInterval = setInterval(() => {
        // Only fetch in the background if the dropdown isn't actively open 
        // to prevent UI layout jumps while the user is reading
        if (!this.showNotifications) {
          this.fetchNotifications();
        }
      }, 1000); 
    },

    async fetchNotifications() {
      try {
        const response = await api.get('/notifications/all');
        // Overwrite the array to ensure Vue reactivity triggers
        this.notifications = response.data.notifications?.data || response.data.notifications || response.data.data || [];
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },

    initializeEcho() {
      if (window.Echo && this.currentUser) {
        window.Echo.private(`App.Models.User.${this.currentUser.id}`)
          .notification((notification) => {
            
            // Fix reactivity: Create a brand new array instead of using unshift()
            const newNotification = {
              id: notification.id,
              data: notification,
              read_at: null,
              created_at: new Date().toISOString()
            };
            
            this.notifications = [newNotification, ...this.notifications];

            if (window.M && window.M.toast) {
              let toastHtml = `<span style="font-weight: 500;">${notification.message}</span>`;
              if (notification.url) {
                toastHtml += `<button class="btn-flat toast-action" onclick="window.location.href='${notification.url}'" style="color: #fff; font-weight: bold; margin-left: 15px;">VIEW</button>`;
              }
              window.M.toast({
                html: toastHtml,
                classes: 'rounded pink accent-3 white-text',
                displayLength: 5000
              });
            }
          });
      }
    },

    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications) {
        this.showProfileMenu = false;
        this.fetchNotifications(); 
      }
    },

    async handleNotificationClick(notification) {
      // Reactivity fix: Reassign the property using a map to ensure Vue detects the change
      this.notifications = this.notifications.map(n => {
        if (n.id === notification.id) return { ...n, read_at: new Date().toISOString() };
        return n;
      });

      if (notification.data.url) {
        this.showNotifications = false;
        this.$router.push(notification.data.url);
      }

      try {
        await api.post(`/notifications/${notification.id}/read`);
      } catch (error) {
        console.error("Error marking notification read:", error);
      }
    },

    async markAllAsRead() {
      try {
        await api.post('/notifications/read-all');
        // Reactivity fix: Update the whole array
        this.notifications = this.notifications.map(n => ({ ...n, read_at: new Date().toISOString() }));
      } catch (error) {
        console.error("Error marking all read:", error);
      }
    },

    closeSidebarOnMobile() {
      if (window.innerWidth <= 992) {
        document.body.classList.remove("mobile-active");
        this.showMobileAdminMenu = false;
      }
    },

    openForcePasswordModal() {
      if (this.forcePasswordModalInstance) {
        this.forcePasswordModalInstance.open();
        this.$nextTick(() => {
          if (typeof window.M !== 'undefined') window.M.updateTextFields();
        });
      }
    },

    async submitNewPassword() {
      this.forcePasswordError = "";

      if (this.forcePasswordForm.password.length < 8) {
        this.forcePasswordError = "Password must be at least 8 characters long.";
        return;
      }

      if (this.forcePasswordForm.password !== this.forcePasswordForm.password_confirmation) {
        this.forcePasswordError = "Passwords do not match.";
        return;
      }

      this.forcePasswordLoading = true;
      try {
        const response = await api.post('/user/setup-new-password', this.forcePasswordForm);
        
        if (typeof window.M !== 'undefined') {
          window.M.toast({ html: response.data.message, classes: 'green rounded' });
        }
        
        if (this.forcePasswordModalInstance) {
          this.forcePasswordModalInstance.close();
        }
        setTimeout(() => {
          window.location.reload(); 
        }, 1000);

      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.errors?.password?.[0] || error.response?.data?.message || 'Failed to update password.';
        this.forcePasswordError = msg;
      } finally {
        this.forcePasswordLoading = false;
      }
    },

    openChangePasswordModal() {
      this.showProfileMenu = false; 
      this.showMobileAdminMenu = false; 
      document.body.classList.remove("mobile-active"); 
      
      this.changePasswordError = "";
      this.changePasswordForm = { old: "", new: "", confirm: "" };
      this.isChangeOldVisible = false;
      this.isChangeNewVisible = false;
      this.isChangeConfirmVisible = false;
      
      if (this.changePasswordModalInstance) {
        this.changePasswordModalInstance.open();
        this.$nextTick(() => {
          if (typeof window.M !== 'undefined') window.M.updateTextFields();
        });
      }
    },

    closeChangePasswordModal() {
      if (this.changePasswordModalInstance) {
        this.changePasswordModalInstance.close();
      }
    },

    async submitChangePassword() {
      this.changePasswordError = "";

      if (!this.changePasswordForm.old || !this.changePasswordForm.new || !this.changePasswordForm.confirm) {
        this.changePasswordError = "Please fill in all password fields.";
        return;
      }

      if (this.changePasswordForm.new.length < 8) {
        this.changePasswordError = "New password must be at least 8 characters long.";
        return;
      }

      if (this.changePasswordForm.new !== this.changePasswordForm.confirm) {
        this.changePasswordError = "New passwords do not match.";
        return;
      }

      this.changePasswordLoading = true;
      try {
        const response = await api.post('/change-password', this.changePasswordForm);
        
        if (typeof window.M !== 'undefined') {
          window.M.toast({ html: response.data.message || 'Password changed successfully', classes: 'green rounded' });
        }
        
        if (this.changePasswordModalInstance) {
          this.changePasswordModalInstance.close();
        }

      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.errors?.new?.[0] || error.response?.data?.errors?.password?.[0] || error.response?.data?.message || 'Failed to update password.';
        this.changePasswordError = msg;
      } finally {
        this.changePasswordLoading = false;
      }
    },

    hasAccess(allowedPositions) {
      if (!allowedPositions) return true;

      let userPositionId = null;
      let userRole = null;
      
      if (this.currentUser) {
        userRole = this.currentUser.role;

        if (this.currentUser.employee && this.currentUser.employee.position_id) {
          userPositionId = Number(this.currentUser.employee.position_id);
        } else if (userRole === 'superadmin') {
          userPositionId = 0;
        }
      }

      if (userRole === 'admin' && allowedPositions.includes(8)) {
        return true;
      }

      // District heads flagged by the backend (SVTRO / TRO I / PURO) see the
      // same menu items a Chief (3) does. Their APIs stay office-scoped.
      if (this.currentUser?.employee?.is_district_chief && allowedPositions.includes(3)) {
        return true;
      }

      if (userPositionId === null) return false;

      return allowedPositions.includes(userPositionId);
    },

    hasPosition(allowedPositions) {
      if (!this.currentUser) return false;
      if (this.currentUser.role === 'superadmin') return true;

      const pos = this.currentUser.employee && this.currentUser.employee.position_id != null
        ? Number(this.currentUser.employee.position_id)
        : null;

      return pos !== null && allowedPositions.includes(pos);
    },

    hasNoAccess(notAllowedPositions) {
      return !this.hasAccess(notAllowedPositions);
    },

    async fetchCurrentUser() {
      try {
        const response = await api.get('/user');
        this.currentUser = response.data;
        localStorage.setItem('hrdos_user', JSON.stringify(response.data));
        this.initializeEcho();
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    getDisplayName() {
      if (!this.currentUser) return 'Loading...';
      if (this.currentUser.employee && this.currentUser.employee.first_name) {
        const first = this.currentUser.employee.first_name;
        const last = this.currentUser.employee.last_name || '';
        return `${first} ${last}`.trim();
      }
      return this.currentUser.username || 'System Admin';
    },

    getProfilePhoto() {
      if (this.currentUser?.employee?.profile_photo) {
        const baseUrl = apiURL.replace(/\/api\/?$/, '');
        return `${baseUrl}/storage/${this.currentUser.employee.profile_photo}`;
      }

      return defaultPic;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    },

    checkActiveRoute() {
      const employeeRoutes = ['/employees', '/my-registrations', '/add-salary-grade', '/employees-signup-requests', '/add-employee', '/unlock-requests', '/edit-requests'];
      if (employeeRoutes.includes(this.$route.path)) {
        this.openMenu = 'employees';
      }

      const leaveRoutes = ['/apply-leave', '/my-leave-requests', '/leave-management', '/leave-balances'];
      if (leaveRoutes.includes(this.$route.path) || this.$route.path.startsWith('/leave-action')) {
        this.openMenu = 'leave';
      }

      const dtrRoutes = ['/admin/dtr-upload', '/hr/dtr/review', '/employee/dtr', '/chief-dtr-disputes', '/chief/dtr/employees'];
      if (dtrRoutes.includes(this.$route.path) || this.$route.path.startsWith('/chief/dtr/review')) {
        this.openMenu = 'dtr';
      }
      
      const trainingRoutes = ['/admin/training-masterlist', '/employee/my-trainings', '/hr/training-approvals', '/training-certificates/sign'];
      if (trainingRoutes.includes(this.$route.path)) {
        this.openMenu = 'trainings';
      }

      // Employee Forms — every page reachable from its sub-menu, plus a single employee's file.
      const d201Routes = ['/201management', '/201queue', '/201archive', '/my-201-file', '/service-record-queue'];
      if (d201Routes.includes(this.$route.path) || this.$route.path.startsWith('/201files/')) {
        this.openMenu = 'd201';
      }
    },

    extractPositionTitleInParentheses(title) {
      if (!title) return '';
      const match = title.match(/\(([^)]+)\)/);

      return match ? match[1] : title;
    },

    toggleAccordion(menuName) {
      this.openMenu = this.openMenu === menuName ? null : menuName;
    },

    toggleSidebar() {
      const width = window.innerWidth;
      if (width > 992) {
        this.collapsed = !this.collapsed;
        document.body.classList.toggle("collapsed");
      } else {
        document.body.classList.toggle("mobile-active");
      }
      this.showMobileAdminMenu = false;
    },

    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
      if (this.showProfileMenu) {
        this.showNotifications = false;
      }
    },

    logout() {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("hrdos_user");
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.password-toggle:hover {
  color: #1565c0;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  z-index: 1200;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-sidebar {
  width: 300px;
  position: fixed;
  top: 72px;
  left: 0;
  bottom: 0;
  z-index: 1100;
  transition: transform 0.3s ease, width 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  margin-top: 72px;
  margin-left: 300px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 72px);
  transition: margin-left 0.3s ease;
}

.notification-dropdown {
  position: absolute;
  top: 45px;
  right: -10px;
  width: 320px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  z-index: 2000;
  transform-origin: top right;
  animation: slideDown 0.2s ease-out;
}

.profile-dropdown {
  position: absolute;
  top: 55px;
  right: 0;
  width: 200px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  z-index: 2000;
  transform-origin: top right;
  animation: slideDown 0.2s ease-out;
}

.profile-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}

.profile-dropdown-item:hover {
  background-color: #ffebee;
}

.profile-dropdown-item-1 {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}

.profile-dropdown-item-1:hover {
  background-color: #ebedff;
}

.dropdown-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.dropdown-content-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.notif-section-title {
  padding: 8px 16px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #757575;
  text-transform: uppercase;
  background-color: #f4f6f9;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e0e0e0;
}

.notification-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  display: flex;
  align-items: flex-start;
  position: relative;
}

.read-notif {
  background-color: #ffffff;
  border-bottom: 1px solid #eeeeee;
  border-left: 4px solid transparent;
}

.read-notif:hover {
  background-color: #f5f5f5;
}

.unread-notif {
  background-color: #e8eaf6; 
  border-left: 4px solid #3f51b5; 
  border-bottom: 1px solid #c5cae9;
  margin-bottom: 2px;
}

.unread-notif:hover {
  background-color: #c5cae9;
}

.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 6px;
  margin-right: 12px;
  flex-shrink: 0;
}

.notif-title {
  font-size: 0.9rem;
  margin-bottom: 2px;
  line-height: 1.2;
}

.notif-text {
  font-size: 0.85rem;
  line-height: 1.3;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

body {
  margin: 0;
  overflow-x: hidden;
  background-color: #f4f6f9;
}

.bold {
  font-weight: 600 !important;
}

.custom-sidebar::-webkit-scrollbar {
  width: 6px;
}

.custom-sidebar::-webkit-scrollbar-thumb {
  background-color: #e0e0e0;
  border-radius: 4px;
}

.sidebar-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  flex: 1 0 auto;
}

.nav-item {
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.nav-link,
.custom-collapse-header {
  display: flex;
  padding: 12px 16px;
  text-decoration: none;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.nav-item:not(.active-nav):hover .nav-link,
.nav-item:not(.active-nav):hover .custom-collapse-header {
  background-color: #f5f5f5;
  transform: translateX(4px);
}

.nav-item:not(.active-nav):hover .nav-link i,
.nav-item:not(.active-nav):hover .nav-link div,
.nav-item:not(.active-nav):hover .custom-collapse-header i,
.nav-item:not(.active-nav):hover .custom-collapse-header div {
  color: #283593 !important;
}

.active-nav {
  box-shadow: none !important;
}

.custom-collapse-wrapper {
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

.custom-collapse-body {
  width: 100%;
  transition: max-height 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.sub-nav-list {
  margin: 0;
  padding: 5px 0 10px 0;
  list-style: none;
}

.sub-nav-link {
  padding: 10px 16px 10px 48px;
  font-size: 0.9rem;
  transition: color 0.2s ease, padding-left 0.2s ease;
  text-decoration: none;
}

/* NEW: Styles for the active sub-nav */
.active-sub-nav {
  background-color: rgba(40, 53, 147, 0.08);
  border-left: 4px solid #283593;
  border-radius: 0 16px 16px 0;
  margin-right: 16px;
}

.sidebar-logout-btn {
  position: sticky !important;
  bottom: 0 !important;
  background-color: #ffebee !important; /* Softer red for Material Design */
  width: 100% !important;
  margin: 0 !important;
  border-top: 1px solid #ffcdd2;
  z-index: 10;
}

.sidebar-option-btn {
  position: sticky !important;
  bottom: 0 !important;
  background-color: #fbffeb !important;
  width: 100% !important;
  margin: 0 !important;
  border-top: 1px solid #f5ffcd;
  z-index: 10;
}

.sub-nav-link:hover {
  color: #283593 !important;
  padding-left: 52px;
}

.sub-dot {
  margin-right: 12px;
  font-size: 1.2rem;
  line-height: 0;
}

.arrow-icon {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.rotate-arrow {
  transform: rotate(180deg);
}

.hover-icon {
  transition: background-color 0.2s;
}

.hover-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.page-content {
  flex: 1;
  padding: 30px;
  width: 100%;
}

/* NEW: Styles for the mobile admin dropdown and overlay */
.mobile-options-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.dark-hover:hover {
  background-color: #424242 !important;
}

/* Override hover for the mobile options toggle so it doesn't turn red */
.mobile-admin-options-btn {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}
.mobile-admin-options-btn:hover {
  background-color: #f5f5f5 !important;
}
.mobile-admin-options-btn.active-options,
.mobile-admin-options-btn.active-options:hover {
  background-color: #ffeb3b !important;
}

@media only screen and (max-width: 992px) {
  .main-content {
    margin-left: 0;
  }

  .custom-sidebar {
    transform: translateX(-105%);
  }

  body.mobile-active .custom-sidebar {
    transform: translateX(0);
  }

  .sidebar-overlay {
    display: none;
    position: fixed;
    top: 72px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000;
    opacity: 0.5;
    z-index: 1050;
  }

  body.mobile-active .sidebar-overlay {
    display: block;
  }
}

@media only screen and (max-width: 600px) {
  .page-content {
    padding: 15px;
  }
}
</style>

<style>
.skeleton {
  background-color: #bdbdbd;
  background-image: linear-gradient(135deg,
      #bdbdbd 30%,
      #e0e0e0 50%,
      #bdbdbd 70%);
  background-size: 1200% 600%;
  background-repeat: no-repeat;
  animation: smooth-shimmer 2.5s infinite linear;
}

.skeleton-text {
  height: 14px;
  border-radius: 4px;
  margin: 5px 0;
}

.skeleton-circle {
  border-radius: 50%;
}

.skeleton-button {
  height: 32.4px;
  width: 54px;
  border-radius: 6px;
}

@keyframes smooth-shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.modal-overlay,
.modal-backdrop {
  z-index: 1300 !important;
}

.modal,
.dialog-box {
  z-index: 1301 !important;
}

.centered-modal {
  top: 50% !important;
  transform: translateY(-50%) !important;
}

/* Desktop Sidebar Collapse Styles */
body.collapsed .custom-sidebar {
  transform: translateX(-105%);
}

body.collapsed .main-content {
  margin-left: 0;
}
</style>
